interface TeamColors {
  primary: string
  secondary: string
  team: string
}

export const teamColors: TeamColors[] = [
  {
    primary: 'rgba(221,0,0,1)',
    secondary: '#fff',
    team: 'Nottingham Forest',
  },
  {
    primary: 'rgba(221,0,0,1)',
    secondary: '#fff',
    team: "Nott'm Forest",
  },
  {
    primary: 'rgba(27,69,143,1)',
    secondary: '#fff',
    team: 'Crystal Palace',
  },
  {
    primary: 'rgba(255,255,255,1)',
    secondary: 'rgba(0,0,0,1)',
    team: 'Fulham',
  },
  {
    primary: 'rgba(218,41,28,1)',
    secondary: '#fff',
    team: 'Man Utd',
  },
  {
    primary: 'rgba(0,51,153,1)',
    secondary: '#fff',
    team: 'Everton',
  },
  {
    primary: '#fff',
    secondary: 'rgba(19,34,87,1)',
    team: 'Spurs',
  },
  {
    primary: 'rgba(181,14,18,1)',
    secondary: '#000',
    team: 'Bournemouth',
  },
  {
    primary: 'rgba(108,171,221,1)',
    secondary: 'rgba(28, 44, 91, 1)',
    team: 'Man City',
  },
  {
    primary: 'rgba(3,70,148,1)',
    secondary: 'rgba(255,255,255,1)',
    team: 'Chelsea',
  },
  {
    primary: 'rgba(238,39,55,1)',
    secondary: '#fff',
    team: 'Sheffield Utd',
  },
  {
    primary: 'rgba(0,0,0,1)',
    secondary: '#fff',
    team: 'Newcastle',
  },
  {
    primary: 'rgba(108,29,69,1)',
    secondary: 'rgba(153,214,234,1)',
    team: 'Burnley',
  },
  {
    primary: 'rgba(215,25,33,1)',
    secondary: '#fff',
    team: 'Brentford',
  },
  {
    primary: 'rgba(253,185,19,1)',
    secondary: 'rgba(0,0,0,1)',
    team: 'Wolves',
  },
  {
    primary: 'rgba(0,0,0,1)',
    secondary: 'rgba(247,143,30,1)',
    team: 'Luton',
  },
  {
    primary: 'rgba(103,14,54,1)',
    secondary: 'rgba(149,191,229,1)',
    team: 'Aston Villa',
  },
  {
    primary: 'rgba(0,87,184,1)',
    secondary: '#fff',
    team: 'Brighton',
  },
  {
    primary: 'rgba(200,16,46,1)',
    secondary: '#fff',
    team: 'Liverpool',
  },
  {
    primary: 'rgba(122,38,58,1)',
    secondary: 'rgba(27,177,231,1)',
    team: 'West Ham',
  },
  {
    primary: 'rgb(128, 2, 2)',
    secondary: 'rgba(255,255,255,1)',
    team: 'FC Nürnberg',
  },
  {
    primary: 'rgb(164, 0, 71)',
    secondary: 'rgba(237, 187, 0, 1)',
    team: 'Barcelona',
  },
  {
    primary: 'rgba(28, 15, 88, 1)',
    secondary: 'rgb(215, 50, 32)',
    team: 'MLS All-Stars',
  },
  {
    primary: 'rgba(229, 27, 34, 1)',
    secondary: 'rgb(255, 255, 255)',
    team: 'Monaco',
  },
  {
    primary: 'rgb(240, 0, 0)',
    secondary: 'rgb(168, 134, 45)',
    team: 'PSV',
  },
  {
    primary: 'rgb(236, 28, 36)',
    secondary: 'rgb(255, 242, 0)',
    team: 'Lens',
  },
  {
    primary: 'rgb(244, 51, 51)',
    secondary: 'rgb(199, 145, 0)',
    team: 'Sevilla',
  },
  {
    primary: 'rgb(0,83,160)',
    secondary: 'rgb(253,190,17)',
    team: 'Leicester',
  },
  {
    primary: 'rgb(222,44,55)',
    secondary: '#fff',
    team: 'Ipswich',
  },
  {
    primary: 'rgb(215, 25, 32)',
    secondary: 'rgb(19, 12, 14)',
    team: 'Southampton',
  },
  {
    primary: '#ee2523',
    secondary: '#000',
    team: 'Athletic Club',
  },
  {
    primary: '#FFCD00',
    secondary: '#1D428A',
    team: 'Leeds',
  },
  {
    primary: '#eb172b',
    secondary: '#000',
    team: 'Sunderland',
  },
  {
    primary: '#1d4289',
    secondary: '#fff',
    team: 'Wigan Athletic',
  },
  {
    // FC Kairat Almaty
    primary: '#F9D100',
    secondary: '#000',
    team: 'Kairat Almaty',
  },
  {
    primary: '#E32221',
    secondary: '#000',
    team: 'Leverkusen',
  },
  {
    primary: '#F5A800',
    secondary: '#003087',
    team: 'Mansfield Town',
  },
  {
    primary: '#DC052D',
    secondary: '#0066B2',
    team: 'Bayern Munich',
  },
  {
    primary: '#FFFFFF',
    secondary: '#FEBE10',
    team: 'Real Madrid',
  },
  {
    primary: '#004170',
    secondary: '#FFFFFF',
    team: 'PSG',
  },
  {
    primary: '#6CADDF',
    secondary: '#1C2C5B',
    team: 'Portsmouth',
  },
  {
    primary: '#CB3524',
    secondary: '#272E61',
    team: 'Atletico Madrid',
  },
  {
    primary: '#3CA1DC',
    secondary: '#FFFFFF',
    team: 'Coventry',
  },
  {
    primary: '#F18A01',
    secondary: '#000000',
    team: 'Hull',
  },
  {
    primary: '#00954C',
    secondary: '#FFFFFF',
    team: 'Real Betis',
  },
  {
    primary: '#D8232A',
    secondary: '#FFFFFF',
    team: 'Girona',
  },
  {
    primary: '#FDE100',
    secondary: '#000000',
    team: 'Borussia Dortmund',
  },
  {
    primary: '#005BAC',
    secondary: '#FFFFFF',
    team: 'Como',
  },
]
